import apiClient from './apiClient';
import { API_CONFIG } from '../config';

class BookingService {
  async listBookings(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        query.set(key, value);
      }
    });

    const suffix = query.toString();
    const response = await apiClient.get(
      suffix ? `${API_CONFIG.ENDPOINTS.BOOKING.LIST}?${suffix}` : API_CONFIG.ENDPOINTS.BOOKING.LIST
    );

    const payload = response?.data;
    if (Array.isArray(payload)) {
      return payload;
    }
    if (Array.isArray(payload?.records)) {
      return payload.records;
    }
    if (Array.isArray(payload?.items)) {
      return payload.items;
    }
    return [];
  }

  async createBooking(payload) {
    const response = await apiClient.post(API_CONFIG.ENDPOINTS.BOOKING.CREATE, payload);
    return response.data;
  }

  async getBookingById(id) {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.BOOKING.GET_BY_ID(id));
    return response.data;
  }

  async updateBooking(id, payload) {
    const response = await apiClient.put(API_CONFIG.ENDPOINTS.BOOKING.UPDATE(id), payload);
    return response.data;
  }

  async deleteBooking(id) {
    const response = await apiClient.delete(API_CONFIG.ENDPOINTS.BOOKING.DELETE(id));
    return response.data;
  }

  async updateBookingStatus(id, status) {
    const response = await apiClient.request(API_CONFIG.ENDPOINTS.BOOKING.UPDATE_STATUS(id, status), {
      method: API_CONFIG.HTTP_METHODS.PATCH
    });
    return response.data;
  }

  async getBookingsByPanditId(panditId) {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.BOOKING.LIST_BY_PANDIT(panditId));
    return Array.isArray(response.data) ? response.data : [];
  }

  async getBookingsByUserId(userId) {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.BOOKING.LIST_BY_USER(userId));
    return Array.isArray(response.data) ? response.data : [];
  }
}

const bookingService = new BookingService();

export default bookingService;
